/* eslint-disable react-native/no-inline-styles */
import React, { useContext, useEffect, useState } from 'react';
import { MediaStream, RTCView } from '@dyteinternals/react-native-webrtc';
import { View } from 'react-native';
import UserAvatar from 'react-native-user-avatar';
import { useRef } from 'react';
import { Peer } from './types/dyte-client';
import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteSpinner from './components/DyteSpinner';
import { DyteUIContext } from './lib/context-provider/ui-context';

type Props = {
  participant: Peer;
  width: number;
  height?: number;
  isScreenshare?: boolean;
  mirrorVideo?: boolean;
};

export default function PeerView(props: Props) {
  const [peerStream, setPeerStream] = useState(new MediaStream(undefined));
  const self = useDyteSelector((m) => m.self);
  const { participant } = props;
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const {
    videoTrack,
    videoEnabled,
    picture,
    name,
    screenShareEnabled,
    screenShareTracks,
  } = participant;
  const videoTrackRef = useRef(null);
  // eslint-disable-next-line no-shadow
  const setVideoTrack = (videoTrack: any) => {
    if (videoTrack) {
      const stream = new MediaStream(undefined);
      stream.addTrack(videoTrack);
      setPeerStream(stream);
    }
  };

  useEffect(() => {
    if (
      props.isScreenshare &&
      screenShareTracks?.video &&
      screenShareEnabled &&
      videoTrackRef.current?.id !== screenShareTracks.video.id
    ) {
      setVideoTrack(screenShareTracks?.video);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenShareEnabled, screenShareTracks?.video]);

  useEffect(() => {
    // console.log('eee', videoEnabled, videoTrack);
    if (!props.isScreenshare && videoTrackRef.current?.id !== videoTrack?.id) {
      setVideoTrack(videoTrack);
      videoTrackRef.current = videoTrack;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoEnabled, videoTrack]);

  const { height: propsHeight, width } = props;
  const height = propsHeight || Math.floor(width * 0.5625);
  const video =
    self.mediaPermissions.video === 'ACCEPTED'
      ? self.getCurrentDevices().video
      : null;
  const renderVideo = () => {
    return (
      <RTCView
        //@ts-ignore
        objectFit={props.isScreenshare ? 'contain' : 'cover'}
        style={{ flex: 1 }}
        streamURL={peerStream.toURL()}
        mirror={
          props.mirrorVideo ?? video?.facing === 'environment' ? false : true
        }
        zOrder={1}
      />
    );
  };

  const renderVideoDisabled = () => {
    return (
      <View
        style={[
          { justifyContent: 'center' },
          { alignItems: 'center' },
          { width: width - 8 },
          { height: height - 8 },
        ]}
      >
        {videoEnabled ? (
          <DyteSpinner />
        ) : (
          <UserAvatar
            size={50}
            src={picture}
            name={(name ?? 'Dyte').trim().length !== 0 ? name : 'Dyte'}
            bgColor={colors.brand[500]}
            textColor={colors.textOnBrand}
          />
        )}
      </View>
    );
  };

  return (
    <View
      style={[
        {
          backgroundColor: colors.videoBg,
          borderRadius: 8,
          width: width - 8,
          height: height - 8,
          overflow: 'hidden',
        },
      ]}
    >
      {((!props.isScreenshare && videoEnabled && videoTrack) ||
        (props.isScreenshare &&
          screenShareEnabled &&
          screenShareTracks?.video)) &&
      peerStream._tracks.length > 0
        ? renderVideo()
        : renderVideoDisabled()}
    </View>
  );
}

PeerView.defaultProps = {
  height: 0,
};
